var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareSolid = function SvgShareSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.337 3.14a1.5 1.5 0 0 1 1.2-.552c.407.01.714.213.868.323a8.287 8.287 0 0 1 .566.462l8.49 7.277c.105.09.227.194.324.293.11.113.266.292.358.55a1.5 1.5 0 0 1 0 1.014 1.514 1.514 0 0 1-.358.55c-.098.1-.219.203-.323.293l-8.518 7.3a8.27 8.27 0 0 1-.539.439c-.154.11-.461.313-.868.323a1.5 1.5 0 0 1-1.2-.552c-.257-.315-.302-.68-.319-.87a8.277 8.277 0 0 1-.018-.693v-3.1a10.4 10.4 0 0 0-6.23 3.605A1 1 0 0 1 2 19.163v-.612a10.667 10.667 0 0 1 8-10.322V4.703c0-.245 0-.492.018-.693.017-.19.062-.555.32-.87Z",
    fill: "currentcolor"
  })));
};
export default SvgShareSolid;